import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { useStores } from '~/hooks/useStore';

interface HeaderMainShopCategoresListProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {}

export const HeaderMainShopCategoresList =
  observer<HeaderMainShopCategoresListProps>(({ className, ...props }) => {
    const { shopCategories } = useStores();

    return (
      <div {...props} className={cn('flex gap-10', className)}>
        {shopCategories.mainCategories.slice(0, 5).map((category) => (
          <Link key={category.id} to={`/c/${category.id}?showProducts=true`}>
            <Typography.Text300Medium className="text-center text-graphic-regular-white transition-colors duration-300 group-data-[scrolled=true]:text-text-primary">
              {category.name}
            </Typography.Text300Medium>
          </Link>
        ))}
      </div>
    );
  });
HeaderMainShopCategoresList.displayName = 'HeaderMainShopCategoresList';
